<template>
  <div class="access-pending d-flex justify-center align-center">
    <v-card class="pa-8 text-center" elevation="0" width="520">
      <v-icon icon="mdi-clock-outline" size="48" color="primary" class="mb-4" />
      <div class="text-h6 mb-2">{{ getTranslation('$vuetify.accessPending.title') }}</div>
      <p class="text-body-2 mb-6">{{ getTranslation('$vuetify.accessPending.text') }}</p>

      <v-btn v-if="cockpitUrl" :href="cockpitUrl" color="primary" class="text-white mb-2" block>
        {{ getTranslation('$vuetify.accessPending.openCockpit') }}
      </v-btn>
      <v-btn variant="text" block to="/logout">
        {{ getTranslation('$vuetify.accessPending.signOut') }}
      </v-btn>
    </v-card>
  </div>
</template>

<script lang="ts">
import { useLocale } from 'vuetify';

/**
 * TECH-2672 — shown when the person has a live share with this domain's company but no module
 * released yet (`dataroom_enabled = false`).
 *
 * Before this page the guard signed them out, which looked like a broken login: accepting an invite
 * grants no module by design, so this is the *expected* first state for an invitee, not an error.
 * The Portfolio in the Cockpit already lists the company at this point, so the way out is a link
 * there rather than a retry.
 */
export default {
  name: 'AccessPending',
  setup() {
    const { t } = useLocale();
    const getTranslation = (path: string) => t(path);
    return { getTranslation };
  },
  computed: {
    // Already configured for this app (env.example): the Cockpit's base URL.
    cockpitUrl(): string {
      const base = import.meta.env.VITE_APP_COCKPIT_URL;
      return base ? `${base}/app/portfolio` : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.access-pending {
  min-height: 100vh;
}
</style>
